import React from 'react';

interface Props {
  color?: string;
  fontSize?: number | string;
}

const Edit: React.FC<Props> = ({ color = 'inherit', fontSize = 'inherit' }) => {
  return (
    <svg
      role="img"
      width="1em"
      height="1em"
      style={{ fontSize: typeof fontSize === 'string' ? fontSize : `${fontSize}px`, color }}
      viewBox="0 0 22 22"
    >
      <rect
        id="Rectangle_1436"
        data-name="Rectangle 1436"
        width="22"
        height="22"
        fill="currentColor"
        opacity="0"
      />
      <g
        id="Icon_feather-edit-3"
        data-name="Icon feather-edit-3"
        transform="translate(1.745 2.148)"
      >
        <path
          id="Path_5936"
          data-name="Path 5936"
          d="M18,30h7.5"
          transform="translate(-6.989 -12.295)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          id="Path_5937"
          data-name="Path 5937"
          d="M18.518,4.961a2.209,2.209,0,0,1,3.115,0,2.187,2.187,0,0,1,0,3.1L8.653,20.989,4.5,22.023l1.038-4.136Z"
          transform="translate(-4.5 -4.318)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export default Edit;
